<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-content">
      <div class="file-upload-type">
        <p>可上传的文件类型为：.jpg,.gif,.png,.avi,.flv,.mpeg,.rm,.rmvb,.mp4,.mp3,.doc,.docx,.xls,.ppt,.pptx,.pdf,.txt,.swf;</p>
        <p>上传的文件大小在2GB以内</p>
        <p>欢迎您上传自己的原创作品，如果您上传的内容不是您本人的原创，请注明原作者或来源；</p>
        <p>请正确填写资源名（资源章节序列），资源分类，资源原作者名，尊重资源版权。资源名和内容严重不符合的，不予以通过；</p>
        <p>您上传的内容应符合国家法律法规的规定，不得损害他人的合法权益。本网保留对不符合规定的内容采取相应处理措施的权力；</p>
        <p>注：各位老师，上传资源后请耐心等待，若提示"资源加工失败"，再重新上传，期间请勿反复上传。</p>
      </div>
      <div class="toggle_info">
        <div class="toggle">
          <span :class="toggleAcitve==1?'active':''">上传资源</span>
          <span :class="toggleAcitve==2?'active':''">补充资源信息</span>
        </div>
        <span @click="back">返回我的资源</span>
      </div>
      <div v-if="toggleAcitve==1">
        <span
          class="file_uploadBtn"
          id="file_uploadBtn"
          :style="showProgress ? 'display: none' : 'display: block'"
        >
          选择文件<input
            type="file"
            id="file_fileInput"
            accept=".jpg,.gif,.png,.avi,.flv,.mpeg,.rm,.rmvb,.mp4,.mp3,.doc,.docx,.xls,.ppt,.pptx,.pdf,.txt,.swf"
            ref="docFile"
            @change="fileChange"
          >
        </span>
        <div
          class="fileBox"
          id="file_uploadBox"
          style="display: block;"
        >
          <span
            class="pauseBtn"
            id="file_pauseBtn"
            style="display: none;"
          >暂停</span>
          <span
            class="goBtn"
            id="file_goBtn"
            style="display:none;"
          >继续</span>
          <div
            class="filename"
            id="file_filename"
            :style="showProgress ? 'display: block' : 'display: none'"
          >{{formInfo.title}}</div>
          <div
            class="pbar"
            :style="showProgress ? 'display: block' : 'display: none'"
          >
            <div
              class="progress"
              id="file_progress"
              :style="'width: ' + Math.ceil(progressValue * 4.2) + 'px;'"
            ></div>
            <div id="file_percent">{{progressValue}}%</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div v-if="toggleAcitve==2">
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>资源名称</span>
              <input
                type="text"
                autocomplete="off"
                v-model="formInfo.title"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>资源分类:</span>
              <select v-model="formInfo.resourceCategory_id">
                <option value="">请选择</option>
                <option
                  v-for="item in categoryList"
                  :key="item.id"
                  :value="item.id"
                >{{item.title}}</option>
              </select>
              <span
                class="add-subject-btn"
                @click="showSubjectWindow"
              >添加</span>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>资源类型:</span>
              <input
                type="hidden"
                v-model="formInfo.id"
              >
              <select v-model="formInfo.resourceType">
                <option value="">请选择资源类型</option>
                <option :value="1">文本类</option>
                <option :value="2">微课类</option>
                <option :value="3">图形/图像类</option>
                <option :value="4">音频类</option>
                <option :value="5">视频类</option>
                <option :value="6">动画类</option>
                <option :value="7">虚拟仿真类</option>
                <option :value="8">PPT演示文稿</option>
                <option :value="9">网页课件</option>
                <option :value="10">富媒体</option>
                <option :value="11">其他</option>
              </select>
            </div>

            <div class="item">
              <span class="label"><i class="require">*</i>是否原创:</span>
              <input
                type="hidden"
                v-model="formInfo.id"
              >
              <select v-model="formInfo.isOri">
                <option :value="1">是</option>
                <option :value="0">否</option>
              </select>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>作者</span>
              <input
                type="text"
                autocomplete="off"
                v-model="formInfo.author"
                maxlength="25"
              >
            </div>
          </form>
          <span
            class="submitBtn"
            @click="saveResourceInfo"
          >保存资源信息</span>
        </div>
      </div>
      <div
        class="form_overlay"
        id="subject_form_overlay"
        :style="classSubjectWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">自建分类</div>
          <div class="form_content">
            <form id="subjectForm">
              <div class="item">
                <span class="label"><i class="require">*</i>分类名称</span>
                <input
                  type="text"
                  value=""
                  v-model="categoryInfo.title"
                  maxlength="25"
                >
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              class="button close"
              href="javascript:void(0)"
              @click="hideSubjectWindow"
            >取消</a>
            <a
              class="button"
              id="subject_form_submit"
              @click="saveSubject"
            >提交</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ExperimentResource',

  data() {
    return {
      toggleAcitve: 1,
      classSubjectWindow: {},
      categoryList: [],
      formInfo: {
        title: '',
        resourceType: '',
        isOri: 1,
        author: '',
        resourceCategory_id: '',
        createUser_id: this.$store.state.userInfo.profile_id,
        path: '',
        size: ''
      },
      categoryInfo: {
        title: ''
      },
      showProgress: false,
      progressValue: 0
    }
  },
  methods: {
    back() {
      history.go(-1)
    },
    showSubjectWindow() {
      this.classSubjectWindow = {
        visibility: 'visible'
      }
    },
    hideSubjectWindow() {
      this.classSubjectWindow = {}
    },
    // 添加资源分类
    async saveSubject() {
      await this.$http.post('/resource_category/', this.categoryInfo).then((data) => {
        if (data.id) {
          this.$parent.showMsg('添加成功！')
          this.hideSubjectWindow()
          this.getResourceCategory()
        } else {
          this.$parent.showMsg('添加失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('添加失败！')
      })
    },
    // 获取所有资源分类
    async getResourceCategory() {
      await this.$http.get('/resource_category/', {
        page: 1,
        size: 1000
      }).then((data) => {
        this.categoryList = data.results
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('添加失败！')
      })
    },
    async saveResourceInfo() {
      await this.$http.post('/resource/', this.formInfo).then((data) => {
        if (data.id) {
          this.$parent.showMsg('添加成功！')
          this.hideSubjectWindow()
          this.$router.push('/admin/resource_manage')
        } else {
          this.$parent.showMsg('添加失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('添加失败！')
      })
    },
    async fileChange() {
      if (this.$store.state.max_file_size && this.$refs.docFile.files[0].size > this.$store.state.max_file_size) {
        alert('文件大小超过限制！')
        return false
      }
      this.showProgress = true
      const fileRealName = this.$refs.docFile.files[0].name
      const uploadUrl = '/info_files/' + fileRealName
      await this.$http.put(uploadUrl, this.$refs.docFile.files[0], {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (e) => {
          this.progressValue = Math.ceil(e.loaded / e.total * 100)
          this.formInfo.title = this.$refs.docFile.files[0].name
        }
      }).then((data) => {
        this.showProgress = false
        this.progressValue = 0
        this.toggleAcitve = 2

        // 此处处理data
        this.formInfo.path = data
        this.formInfo.size = this.$refs.docFile.files[0].size
      }).catch(() => {
        this.showProgress = false
        this.progressValue = 0
        this.hideUploadWindow()
        this.$parent.showMsg('上传失败！')
      })
    }

  },
  // 计算属性
  computed: {
  },
  mounted() {
    this.getResourceCategory()
  }
}
</script>

<style scoped src="../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../assets/css/resources.css"></style>
<style lang="less" scoped>
.panel-content {
  min-height: 690px;
}
.toggle_type {
  margin: 20px 0;
  li {
    display: inline-block;
    font-size: 16px;
    color: #999;
    padding: 10px 20px;
    box-sizing: border-box;
  }
  li.active {
    color: #2aa9a9;
    border-bottom: 1px solid #2aa9a9;
  }
}

.file-upload-type {
  p {
    line-height: 2;
    font-size: 16px;
    color: #999;
    &:last-child {
      color: red;
    }
  }
}
.toggle_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  height: 37px;
  margin: 0 0 40px;
  > span {
    font-size: 14px;
    line-height: 36px;
    color: #009999;
    cursor: pointer;
  }
}
.toggle {
  span {
    display: inline-block;
    height: 36px;
    line-height: 36px;
    color: #444;
    padding: 0 20px;
    border: 1px solid #dadada;
    border-bottom: none;
    background: #f8f8f8;
    margin-right: -1px;
    &:first-child {
      border-right: none;
    }
  }
  .active {
    background: #09c6cd;
    border-color: #09c6cd;
    color: #fff;
  }
}
.file_uploadBtn {
  width: 140px;
  height: 42px;
  background: #fe6161;
  border-radius: 0;
}
.progress {
  height: 10px;
  border-radius: 10px;
  width: 0;
  background: #979797;
  position: absolute;
  top: 0;
  left: 0;
}
.add-subject-btn {
  display: inline-block;
  width: 54px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #009999;
  border: 1px solid #009999;
  color: #fff;
  cursor: pointer;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.submitBtn {
  background: none repeat scroll 0 0 #f9f9f9;
  border: 1px solid #dbdbdb;
  color: #444;
  display: block;
  height: 42px;
  line-height: 42px;
  margin-top: 40px;
  text-align: center;
  width: 140px;
  cursor: pointer;
}
.enable {
  background: none repeat scroll 0 0 #0bb8f0;
  color: #fff;
  border: 1px solid #0bb8f0;
}
</style>
